export { default } from './use-path-contains';
